import apiClient from './api';

const faceRecognitionConfigService = {
  async getConfig() {
    try {
      const response = await apiClient.get('/admin/face-recognition-config/');
      return { success: true, data: response.data };
    } catch (error) {
      return this.handleError(error);
    }
  },

  async updateConfig(payload) {
    try {
      const response = await apiClient.patch('/admin/face-recognition-config/', payload);
      return { success: true, data: response.data };
    } catch (error) {
      return this.handleError(error);
    }
  },

  async resetConfig() {
    try {
      const response = await apiClient.post('/admin/face-recognition-config/reset/');
      return { success: true, data: response.data };
    } catch (error) {
      return this.handleError(error);
    }
  },

  handleError(error) {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 500) return { success: false, error: 'Server error. Please try again later.' };
      if (status === 403) return { success: false, error: 'You do not have permission to perform this action.' };
      if (status === 401) return { success: false, error: 'Authentication required.' };
      if (data) {
        if (typeof data === 'string') return { success: false, error: data };
        if (data.detail) return { success: false, error: data.detail };
        const fieldErrors = Object.entries(data)
          .map(([field, messages]) => {
            const msg = Array.isArray(messages) ? messages.join(' ') : messages;
            return `${msg}`;
          })
          .join(' | ');
        if (fieldErrors) return { success: false, error: fieldErrors };
      }
    }
    return { success: false, error: error.message || 'An unexpected error occurred.' };
  },
};

export default faceRecognitionConfigService;
